import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    closeMenu();
    
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      window.location.href = '/#' + sectionId;
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = document.querySelector('.header').offsetHeight;
      const elementPosition = element.offsetTop - headerHeight - 20;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleHomeClick = () => {
    closeMenu();
    
    if (location.pathname !== '/') {
      // If not on home page, navigate to home
      window.location.href = '/';
    } else {
      // If already on home page, scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const navItems = [
    { name: 'Home', path: '/', section: 'hero' },
    { name: 'Research', path: '/research', section: 'research' },
    { name: 'Data', href: '/econlinguistics/#data' },
    { name: 'Teaching', path: '/teaching', section: 'teaching' },
    { name: 'Entrepreneurship', path: '/entrepreneurship', section: 'entrepreneurship' },
    { name: 'Contact', path: '/contact', section: 'contact' }
  ];

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <nav className="nav">
            <Link to="/" className="nav-logo" onClick={handleHomeClick}>
              <img src="/favicon.svg" alt="" />
              <span>Sasan Mansouri</span>
            </Link>

            <button className="nav-toggle" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>

            <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              {navItems.map((item) => (
                <li key={item.name} className="nav-item">
                  {item.href ? (
                    <a className="nav-link" href={item.href} onClick={closeMenu}>
                      {item.name}
                    </a>
                  ) : item.name === 'Home' ? (
                    <button
                      className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                      onClick={handleHomeClick}
                    >
                      {item.name}
                    </button>
                  ) : (
                    <button
                      className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                      onClick={() => scrollToSection(item.section)}
                    >
                      {item.name}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>
      
      {/* Scroll indicator */}
      <div className="scroll-indicator" id="scrollIndicator"></div>
    </>
  );
};

export default Header; 